import { columnHelper } from '@leaftrade/leaftrade-component-library';
import React, { useContext } from 'react';
import QuickOrderItemCell from './QuickOrderItemCell';
import QuickOrderQuantityCell from './QuickOrderQuantityCell';
import QuickOrderQuantityCellContext from './QuickOrderQuantityCellContext';
import {
  QuickOrderDeleteCell,
  QuickOrderQuantityTotalCell,
  QuickOrderSubtotalCell,
} from './QuickOrderSummaryCells';

const ALL_COLUMN_TOOLTIP =
  'Changes made on the highlighted All column will update all selected carts unless otherwise specified.';

const QuickOrderQuantityTableCell = (info) => {
  const quantityCellStateRef = useContext(QuickOrderQuantityCellContext);
  const { isAllLocations, location } = info.column.columnDef.meta;

  return (
    <QuickOrderQuantityCell
      isAllLocations={isAllLocations}
      item={info.row.original}
      location={location}
      quantityCellStateRef={quantityCellStateRef}
      rowIndex={info.row.index}
    />
  );
};

export const buildQuickOrderColumns = ({
  batchQueuesEnabled,
  displayLiveInventoryCount,
  selectedLocations,
  slug,
}) => {
  const dynamicColumnCount =
    selectedLocations.length + (selectedLocations.length > 1 ? 1 : 0);
  const dynamicColumnSizePercentage = 100 / dynamicColumnCount;

  return [
    columnHelper.accessor('productName', {
      cell: (info) => (
        <QuickOrderItemCell
          batchQueuesEnabled={batchQueuesEnabled}
          displayLiveInventoryCount={displayLiveInventoryCount}
          item={info.row.original}
          slug={slug}
        />
      ),
      cellOverflowDisplay: 'full',
      disableCellTitle: true,
      enableSorting: false,
      frozen: 'left',
      header: 'Item',
      minSize: 320,
      size: 320,
    }),
    ...(selectedLocations.length > 1
      ? [
          columnHelper.accessor('allLocationsQuantity', {
            cell: QuickOrderQuantityTableCell,
            meta: {
              isAllLocations: true,
            },
            cellAlign: 'center',
            cellOverflowDisplay: 'full',
            disableCellTitle: true,
            enableSorting: false,
            header: 'All',
            headerAlign: 'center',
            headerTooltip: ALL_COLUMN_TOOLTIP,
            hideFromColumnToggles: true,
            minSize: 125,
            sizePercentage: dynamicColumnSizePercentage,
          }),
        ]
      : []),
    ...selectedLocations.map((selectedLocation) =>
      columnHelper.accessor(`location-${selectedLocation.id}`, {
        cell: QuickOrderQuantityTableCell,
        meta: {
          location: selectedLocation,
        },
        cellAlign: 'center',
        cellOverflowDisplay: 'full',
        disableCellTitle: true,
        enableSorting: false,
        header: selectedLocation.name,
        headerAlign: 'center',
        hideFromColumnToggles: true,
        minSize: 140,
        sizePercentage: dynamicColumnSizePercentage,
      })
    ),
    columnHelper.accessor('selectedLocationCount', {
      cell: (info) => <QuickOrderQuantityTotalCell item={info.row.original} />,
      cellAlign: 'center',
      enableSorting: false,
      frozen: 'right',
      header: 'Quantity',
      headerAlign: 'center',
      hideFromColumnToggles: true,
      maxSize: 125,
      size: 125,
    }),
    columnHelper.accessor('selectedLocationTotal', {
      cell: (info) => <QuickOrderSubtotalCell item={info.row.original} />,
      cellAlign: 'center',
      enableSorting: false,
      frozen: 'right',
      header: 'Subtotal',
      headerAlign: 'center',
      hideFromColumnToggles: true,
      maxSize: 125,
      size: 125,
    }),
    columnHelper.accessor('delete', {
      cell: (info) => <QuickOrderDeleteCell item={info.row.original} />,
      cellAlign: 'center',
      disableCellTitle: true,
      enableSorting: false,
      frozen: 'right',
      header: '',
      hideFromColumnToggles: true,
      maxSize: 50,
      size: 50,
    }),
  ];
};
